import { getRandomString } from '@/helpers/stringHelper'

export default class WebWorkerService {
	constructor(workerName) {
		// console.log('WebWorkerService constructor')
		this.workerPaths = {
			unzippingDataWorker: '/workers/unzippingDataWorker.js',
			geojsonWorker: '/workers/geojsonWorker.js',
		}

		// RISK(RISK-026)[S3/краш]: класс не имеет метода terminate(); воркеры, создаваемые per-component
		// (LogisticRoutesConstructor.vue, CargoAnalyticsTab.vue), не завершаются при размонтировании —
		// утечка воркеров. Решение: добавить terminate() и вызывать его в onUnmounted. docs/audit/04_risks_register.md (RISK-026)
		this.myWorker = new Worker(this.workerPaths[workerName])

		this.jobs = {}

		this.myWorker.onmessage = (e) => {
			const result = e.data
			const { jobId, payload } = result
			const job = this.jobs[jobId]
			if (job) {
				job.resolve(payload)
			}
		}

		this.myWorker.onerror = (e) => {
			console.log('Error in worker', e)
			const { jobId } = e.data
			const job = this.jobs[jobId]
			if (job) {
				job.reject(e)
			}
		}
	}

	runJob({cmd, payload}) {
		return new Promise((resolve, reject) => {
			const jobId = getRandomString(10)
			this.jobs[jobId] = {
				id: jobId,
				resolve,
				reject,
			}
			this.myWorker.postMessage({
				jobId,
				cmd,
				payload,
			})
		})
	}
}
